import { Row, Col } from 'antd';

const GridResumenGeneral = ({ budget, budget_not_iva, budget_iva, advance, estimadedTotal }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const budgetIva = budget * (budget_iva/100);
    const budgetNotIva = budget * (budget_not_iva / 100);
    const budgetReal = budgetNotIva + budgetIva;


    return (
        <>
            <Col xs={24} md={12}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <h4 className='title-custom'>RESUMEN GENERAL</h4>
                </Row>

                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Presupuesto Real Total:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(budgetReal) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Anticipo Real:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(advance) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Total estimado:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(estimadedTotal) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Total pagado:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(advance+estimadedTotal) || "0.00"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Saldo real:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(budgetReal - (advance+estimadedTotal)) || "0.00"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridResumenGeneral;